<ng-container *ngIf="mode === 'edit'">
  <!-- <label class="col-form-label">{{label}}</label> -->
  <div class="input-group position-absolute" 
        [style.width.px]='inlineview.offsetWidth'>
    <input #inputEditorControl
           class="form-control m-0 bg-white"
           [class.bg-warning]="inputReqflag"
           [class.bg-outline-primary]="!inputReqflag"
           [required]="required"
           (keyup.enter)="onSaveInput()"
           [id]="id"
           [(ngModel)]="value"
           type="text"
           (blur)="onBlur($event)"
           [placeholder]="placeholder"
           [maxlength]="stringlength">
    <!-- <div class="input-group-append">
      <button class="btn btn-outline-primary text-primary border-left-0 bg-white btn-sm mdi mdi-18px mdi-close"
              type="button"
              (click)="onCancelInput()">
      </button>
      <button class="btn btn-outline-primary text-primary border-left-0 bg-white btn-sm mdi mdi-18px mdi-checkbox-marked-circle"
              type="button"
              (click)="onSaveInput()">
      </button>
    </div> -->
  </div>
  <!-- <div *ngIf="inputReqflag"
       class="text-danger">
    {{requiredMessage}}
  </div> -->
</ng-container>

<div class="input-group" [class.hidden]="mode === 'edit'" #inlineview>

  <div 
      class="form-control px-0 mx-0 rounded-0" style="box-shadow:none"
      [ngClass]="{'border-primary border-top-0 border-left-0 border-right-0' : !disabled}"
      [class.border-0]="disabled"
      [class.c-pointer]="!disabled"
     
      (click)="edit(value)"
      tabindex="0">
    {{ IsInputTextEmpty() ? placeholder : value }}
  </div>
  <span *ngIf="!disabled" class="input-group-addon mdi mdi-pencil p-1" (click)="edit(value)"></span>

</div>